import { useEffect } from 'react';
import type { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Route changes: jump to the top, or to the hash target when there is one.
 * Also reports the SPA page view to GA4 (a no-op when GA is not configured).
 */
const ScrollToTop: FC = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      // Let the route render before we look for the target.
      const raf = window.requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollTo(0, 0);
        }
      });
      return () => window.cancelAnimationFrame(raf);
    }

    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);

  useEffect(() => {
    trackPageView(`${pathname}${hash}`);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
